<template>
  <div class="locationErrors-list">
    <Row>
       
    </Row>
    <Table border :columns="list" :data="tablelist" :loading="dataloading"></Table>
     <div style="margin: 10px;overflow: hidden">
        <div style="float: right;">
            <Page ref="listPage" :total="pages.total" :current="pages.page" :page-size="pages.size" show-elevator show-total @on-change="changePage()"></Page>
        </div>
    </div>
  </div>
</template>

<script>
export default {
    name: 'locationErrors-list',
    data () {
        return {
            loading: true,
            dataloading: true,
            thumblist: [],
            pages:{
                page:1,
                size:10,
                total:0
            },
            title:'',
            formItem:{
                'key':'',
            },
            bigDisplay:'',
            list: [
                {
                    title: 'Id',
                    key: 'id',
                    fixed: 'left',
                    width:90
                },
                {
                    title: '报错内容',
                    key: 'describe_err',
                    minWidth:200,
                },
                {
                    title: '正确内容',
                    key: 'address_err',
                    minWidth:200,
                },
                {
                    title: '定位点',
                    key: 'location_title',
                    minWidth:100,
                },

                {
                    title: '用户',
                    key: 'username',
                    minWidth:100,
                },
                {
                    title: '操作',
                    key: 'action',
                    width:80,
                    align: 'left',
                    fixed: 'right',
                    render: (h, params) => {
                        return h('div', [
                            h('Button', {
                                style:{
                                    marginRight:'8px'
                                },
                                props: {
                                    type: 'error',
                                    size: 'small'
                                },
                                on: {
                                    click: () => {
                                        this.remove(params.index,params.row.id)
                                    }
                                }
                            }, '删除')
                        ]);
                    }
                }
            ],
            tablelist: [],
            locationErrors:{
                name:'',
                status:true,
            },
            showModalStatus:false,
            locationErrorsValidate: {
                name: [
                    { required: true, message: '名称必须填写', trigger: 'blur' }
                ],
            },
        }
    },
    created: function () {
        // 取数据
        this.getTableList();
    },
    methods:{
        getTableList:function(){
          this.$api.locationErrors.list({"page":this.pages.page,"size":this.pages.size}).then(res=>{
            this.dataloading = false;
            if(res.code == 200) {
                this.tablelist = res.result.list;
                for (var i in this.tablelist) {
                    this.pages.total = res.result.total;
                    this.$Message.success(res.msg);
                }
            }
          });
          return;
        },
        // 删除
        remove:function(index,id){
            // 弹出确认框
            this.$Modal.confirm({
                title: '警告',
                content: '<p>此操作不可恢复，三思而后行...</p>',
                onOk: () => {
                    this.$api.locationErrors.remove({id:id}).then(res=>{
                        if(res.code == 200)
                        {
                            this.$Message.success(res.msg);
                            this.tablelist.splice(index, 1);
                        }
                    });
                }
            });
        },
         // 翻页
        changePage() {
            this.pages.page = this.$refs['listPage'].currentPage;
            this.renderTable(1);
        },
        // 筛选
        renderTable:function(name) {
            if (name !=1){
                this.pages.page = 1;
             }
            this.dataloading = true;
            var ps = {'key':this.formItem.key,"page":this.pages.page,"size":this.pages.size};
            this.$api.locationErrors.list(ps).then(res=>{
                this.dataloading = false;
                if(res.code == 200)
                {
                    this.tablelist = res.result.list;
                    this.pages.total = res.result.total;
                    this.$Message.success(res.msg);
                }
            });
            return;
        }
    },
}
</script>
